<template>
    <nav class="breadcrumb">
        <a class="breadcrumb-item" href="#">Home</a>
        <a class="breadcrumb-item" href="#">Library</a>
        <a class="breadcrumb-item active" href="#">Data</a>
    </nav>
</template>

<script>
    export default {
    }
</script>